// frontend/src/samkalp-admin/panels/IntegrationsPanel.js
import React from 'react';
import TenantMoodleSettings from '../../components/TenantAdmin/TenantMoodleSettings';

const IntegrationsPanel = ({ slug }) => (
    <div>
        <h6 className="fw-bold text-dark mb-1">Integrations &amp; External Services</h6>
        <p className="text-muted small mb-4">
            Configure third-party platform connections for this centre.
        </p>
        <div className="mb-2 text-uppercase x-small fw-bold text-muted ls-1">Moodle LMS</div>
        <TenantMoodleSettings tenantSlug={slug} />
    </div>
);

export default IntegrationsPanel;
